export default "__VITE_ASSET__lsdiWlFP__"